import { SectionChip } from './SectionChip';
import { DeepLinkTarget, SectionSummary } from './SectionSummary.types';

type SectionChipListProps = {
   readonly summaries: SectionSummary[];
   readonly onDetails: (target: DeepLinkTarget) => void;
};

export const SectionChipList = (props: SectionChipListProps): JSX.Element | null => {
   if (props.summaries.length === 0) {
      return null;
   }

   return (
      <>
         {props.summaries.map((summary) => (
            <SectionChip
               key={`${summary.templateCode}:${summary.sectionId}`}
               summary={summary}
               onDetails={props.onDetails}
            />
         ))}
      </>
   );
};
